"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var config = function config(frame) {
  return function () {
    return {
      name: frame.name,
      ps1: frame.ps1,
      ps2: frame.ps2,
      commands: frame.commands,
      plugins: frame.plugins,
      adapter: frame.adapter
    };
  };
};

var _default = config;
exports.default = _default;